import React from 'react';
import theme from '../../theme';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../store/reducer-main';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Typography from './Typography';
import { formatDate } from '../../../helpers/utils';
import { MembershipType } from '../../../enums/profile';

import UserCardDropdown from './UserCardDropdown';

interface IUserCard {
  className?: string;
  style?: React.CSSProperties;
}

export default function UserCard({
  className,
  style
}: IUserCard) {

  const { userProfile } = useSelector((state: StoreState) => state.profile);
  const products = useSelector((state: StoreState) => state.stripe.products);

  const userData = React.useMemo(() => {
    if (!userProfile || !userProfile.stripeCustomer) return null;
    return userProfile.stripeCustomer;
  }, [userProfile]);

  const planData = React.useMemo(() => {
    const membershipData = userProfile?.membership;
    if (!membershipData) return null;
    if (membershipData.type === MembershipType.TRIAL) return { name: 'PROMO' };
    const idx = products.findIndex(el => el.id === membershipData.stripeProductRef);
    return idx < 0 ? null : products[idx];
  }, [products, userProfile]);

  const renewalDate = React.useMemo(() => {
    const membershipData = userProfile?.membership;
    if (!membershipData) return null;
    const planEndDate = membershipData.type === MembershipType.SUBSCRIPTION
      ? membershipData.subscriptionData.current_period_end * 1000
      : membershipData.tsEnd;
    const date = new Date(planEndDate);
    return formatDate(date);
  }, [userProfile]);

  return (
    <div
      style={{
        borderRadius: theme.sizing.x1_1,
        backgroundColor: theme.color.backgroundSecondary,
        ...style,
      }} className='flex flex-col w-full h-auto p-3'>
        <div className='flex items-center gap-2'>
          <AccountCircleIcon 
            style={{color: 'black', fontSize: theme.sizing.x5}} />
            <div className='flex items-center mr-auto'>
              <Typography
                variant='paragraph'
                colorVariant='primary'
                style={{fontWeight: 700}}>
                {userProfile?.displayName ?? ' - '}
              </Typography>
            </div>
            <UserCardDropdown/>
        </div>
        <div
          className='flex flex-col px-6 mt-4 gap-2'>
            <div className='flex flex-col'>
              <Typography variant='label' colorVariant='textLabel'>Abbonamento</Typography>
              <Typography variant='paragraph' style={{fontWeight: 500}}>{planData?.name ?? '--'}</Typography>
            </div>
            <div className='flex flex-col'>
              <Typography variant='label' colorVariant='textLabel'>Prossimo rinnovo</Typography>
              <Typography variant='paragraph' style={{fontWeight: 500}}>{renewalDate ?? '--'}</Typography>
            </div>
            <div className='flex flex-col'>
              <Typography variant='label' colorVariant='textLabel'>Calcoli residui</Typography>
              <Typography variant='paragraph' style={{fontWeight: 500}}>Infiniti</Typography>
            </div>
        </div>
    </div>
  )
}